/**
 * @description: Mutation 事件类型
 * @author: hwx
 */

export const LOGIN = 'LOGIN' // 登录
export const LOGOUT = 'LOGOUT' // 退出
export const INDEX = 'INDEX' // 回首页
export const MENUNEW = 'MENUNEW' // 菜单
export const SELECTEDMENU = 'SELECTEDMENU' // 选中的一级菜单
export const SELECTTABS = 'SELECTTABS' // 选中的二级菜单
export const SELECTTABSDELETE = 'SELECTTABSDELETE'
export const SELECTEDSIDEBAR = 'SELECTEDSIDEBAR' // 选中的侧边栏
export const PRIVINFO = 'PRIVINFO' // 其他
export const REPORTINFO = 'REPORTINFO' // 报表系统信息
export const AIMODULE = 'AIMODULE'